module.exports = __webpack_public_path__ + "img/35524273.82409b92.png";